import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom/dist";
import { Col, Dropdown, Row } from "react-bootstrap";
import { CasinoProviders } from "../lib/data";

import ProviderLogo1 from "../assets/images/providers/Evolution.jpg";
import ProviderLogo2 from "../assets/images/providers/Ezugi.jpg";
import ProviderLogo3 from "../assets/images/providers/Supernowa.jpg";
import ProviderLogo4 from "../assets/images/providers/XPG.jpg";
import ProviderLogo5 from "../assets/images/providers/Vivogaming.jpg";
import ProviderLogo7 from "../assets/images/providers/OneTouch.jpg";
import ProviderLogo8 from "../assets/images/providers/Pragmaticplay.jpg";
import ProviderLogo9 from "../assets/images/providers/Onlyplay.jpg";

import Img1 from "../assets/images/icons/footer/casino-sigma-europe.webp";
import Img2 from "../assets/images/icons/footer/crypto-casino-affpapa.webp";
import Img3 from "../assets/images/icons/footer/mobile-sigma-africa.webp";
import Img4 from "../assets/images/icons/footer/platform-sigma-asia.webp";

import FootLogo1 from "../assets/images/icons/footer/sigma.webp";
import FootLogo2 from "../assets/images/icons/footer/responsible-gambling.webp";
import FootLogo3 from "../assets/images/icons/footer/gamcare.webp";
import FootLogo4 from "../assets/images/icons/footer/betblocker.webp";
import FootLogo5 from "../assets/images/icons/footer/plus.webp";
import FootLogo6 from "../assets/images/icons/footer/c9.webp";
import FootLogo7 from "../assets/images/icons/footer/leicester.png";
import FootLogo8 from "../assets/images/icons/footer/jason_derulo.webp";

import WhatsappIcon1 from "../assets/images/whatsapp.png";
import TelegramIcon from "../assets/images/Telegram.svg";
import InstaIcon from "../assets/images/Instagram.svg";
import Facebook from "../assets/images/facebook-512.svg";
import Calling from "../assets/images/phone-call.png";

import gcb from "../assets/images/icons/footer/gcb.webp";

import Menu from "../assets/images/icons/list.png";
import Explore from "../assets/images/icons/Contact.png";
import Promotion from "../assets/images/icons/Promotion.png";
import SportsbookIcon from "../assets/images/icons/throw.png";
import SportsIcon from "../assets/images/icons/Sports.png";

import Facebook1 from "../assets/images/facebook-512.svg";
import WhatsappIcon12 from "../assets/images/Whatsapp.svg";
import Calling1 from "../assets/images/phone-call.png";
import TelegramIcon1 from "../assets/images/Telegram.svg";
import InstaIcon1 from "../assets/images/Instagram.svg";
import GamesSearchModal from "../views/components/GamesSearchModal";

const footerPages = [
  "home",
  "sportsbook",
  "casino/evolution",
  "casino/ezugi",
  "gatewaylist",
];

const casinoProvidersGames = [
  {
    code: "evolution",
    name: "Evolution",
    imgUrl: ProviderLogo1,
    type: "evolution",
    status: 1,
  },
  {
    code: "ezugi",
    name: "Ezugi",
    imgUrl: ProviderLogo2,
    type: "ezugi",
    status: 2,
  },
  {
    code: "supernowa",
    name: "Supernowa",
    imgUrl: ProviderLogo3,
    type: "supernowa",
    status: 3,
  },
  {
    code: "xpg",
    name: "XPG",
    imgUrl: ProviderLogo4,
    type: "xpg",
    status: 4,
  },
  {
    code: "vivo",
    name: "Vivo",
    imgUrl: ProviderLogo5,
    type: "vivo",
    status: 5,
  },
  {
    code: "onetouch",
    name: "Onetouch",
    imgUrl: ProviderLogo7,
    type: "onetouch",
    status: 7,
  },
  {
    code: "pragmatic",
    name: "Pragmatic Play",
    imgUrl: ProviderLogo8,
    type: "pragmatic",
    status: 8,
  },
  {
    code: "onlyplay",
    name: "Only Play",
    imgUrl: ProviderLogo9,
    type: "onlyplay",
    status: 9,
  },
];

const Footer = () => {
  const navigate = useNavigate();
  const { appDetails } = useSelector((state) => state.app);
  const location = useLocation();
  const [activePage, setActivePage] = useState("");
  const [showLeftbarToggle, setShowLeftbarToggle] = useState(false);
  const htmlElement = document.documentElement;
  useEffect(() => {
    const matchedValue = footerPages.find((f) =>
      location?.pathname.includes(f)
    );
    if (matchedValue) {
      setActivePage(matchedValue);
    }
  }, [location]);

  const handleToggleClick = () => {
    const realTimeValue = !showLeftbarToggle;
    if (!document.body.classList.contains("leftbat-opened")) {
      htmlElement.style.overflow = "auto";
      document.body.classList.add("leftbat-opened");
    } else {
      htmlElement.style.overflow = "auto";
      document.body.classList.remove("leftbat-opened");
    }
    setShowLeftbarToggle(realTimeValue);
  };

  return (
    <footer className="footer">
      <div className="FooterLinksSection">
        <div className="footerLinks">
          <h2>Casino</h2>
          <ul>
            <li>
              <a href="/slots">Slots</a>
            </li>
            <li>
              <a href="/casino">Live Casino</a>
            </li>
            <li>
              <a href="/casino/ezgevo-blackjack-b">Blackjack</a>
            </li>
            <li>
              <a href="/casino/ezg-italian-roulette">Roulette</a>
            </li>
            <li>
              <a href="/casino/ezg-baccarat">Baccarat</a>
            </li>
          </ul>
        </div>
        <div className="footerLinks">
          <h2>Sports</h2>
          <ul>
            <li>
              <a href="/exchange/Cricket">Exchange</a>
            </li>
            <li>
              <a href="/sportsbook2">Sportsbook</a>
            </li>
          </ul>
        </div>
        <div className="footerLinks">
          <h2>Promo</h2>
          <ul>
            <li>
              <a href="javascript:void(0)">Affiliates</a>
            </li>
            <li>
              <a href="/promotion">Promotions</a>
            </li>

            <li>
              <a href="/referral">Refer a Friend</a>
            </li>
          </ul>
        </div>
        <div className="footerLinks">
          <h2>Support/Legal</h2>
          <ul>
            <li>
              <a href="/contactus">Contact Us</a>
            </li>
            <li>
              <a href="/privacypolicy">Privacy Policy</a>
            </li>
            <li>
              <a href="/responsiblegame">Responsible Gaming</a>
            </li>
          </ul>
        </div>
        <div className="footerLinks">
          <h2>About Us</h2>
          <ul>
            <li>
              <a href="/fairplay">Fair Play</a>
            </li>
            <li>
              <a href="/gamesrule">Games Rules</a>
            </li>
            <li>
              <a href="/terms">Terms and Conditions</a>
            </li>
          </ul>
        </div>
        <div className="footerLinks">
          <h2>Join Our Community</h2>
          <ul>
            <li>
              <a
                href={
                  appDetails?.WHATS_APP_URL != ""
                    ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                    : "#"
                }
                target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
              >
                <img
                  loading="lazy"
                  src={WhatsappIcon1}
                  alt="Whatsapp Icon"
                  width={20}
                  height={20}
                />
              </a>
            </li>
            <li>
              <a
                className="panel"
                href={appDetails?.TELEGRAM != "" ? appDetails?.TELEGRAM : "#"}
                target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
              >
                <img
                  loading="lazy"
                  src={TelegramIcon}
                  alt="Telegram Icon"
                  width={20}
                  height={20}
                />
              </a>
            </li>
            <li>
              <a
                className="panel"
                href={
                  appDetails?.INSTATGRAM != "" ? appDetails?.INSTATGRAM : "#"
                }
                target={appDetails?.INSTATGRAM != "" ? "_blank" : ""}
              >
                <img
                  loading="lazy"
                  src={InstaIcon}
                  alt="Instagram Icon"
                  width={20}
                  height={20}
                />
              </a>
            </li>

            <li>
              <a
                href={appDetails?.FACEBOOK != "" ? appDetails?.FACEBOOK : "#"}
                target={appDetails?.FACEBOOK != "" ? "_blank" : ""}
              >
                <img
                  loading="lazy"
                  src={Facebook}
                  alt="Email Icon"
                  width={20}
                  height={20}
                />
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* <div className="FooterLogoContent">
        <div className="FooterleftPart">
          <a href="/">
            <img loading="lazy"src={appDetails?.LOGO_URL} alt="Logo" />
          </a>
        </div>
      </div> */}

      <div className="copyright">
        <p>Copyright ©2025 Jockey555. ALL RIGHTS RESERVED.</p>
      </div>

      <div className="footer-menu position-fixed start-0 bottom-0 z-index-2 d-block d-lg-none">
        <ul className="d-flex justify-content-evenly m-0 p-0 list-unstyled">
          <li>
            <a
              className={activePage === "sportsbook" ? "active" : ""}
              onClick={() => handleToggleClick()}
              href="javascript:void(0)"
            >
              <img loading="lazy" src={Menu} alt="sports" width={18} />
              <span>Menu</span>
            </a>
          </li>
          <li>
            <a href="/exchange/Inplay">
              <img loading="lazy" src={SportsIcon} alt="ezugi" width={18} />
              <span>Inplay</span>
            </a>
          </li>
          <li>
            <a href="/sportsbook2">
              <img loading="lazy" src={SportsbookIcon} alt="ezugi" width={18} />
              <span>Sportsbook</span>
            </a>
          </li>
          <li>
            <a href="/promotion">
              <img loading="lazy" src={Promotion} alt="aviator" width={18} />
              {/* <GamesSearchModal /> */}
              <span>Promotion</span>
            </a>
          </li>
          {/* <li>
            <a
              className={activePage === "home" ? "active" : ""}
              href="/casino/ezugi"
            >
              <img loading="lazy"src={CasinoIcon} alt="home" />
              <span>Casino</span>
            </a>
          </li> */}

          <Dropdown className="FooterDropdown">
            <Dropdown.Toggle variant="success" id="dropdown-basic">
              <img loading="lazy" src={Explore} alt="evolution" width={18} />
              <span>Support</span>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <ul>
                <li>
                  <a
                    href={
                      appDetails?.WHATS_APP_URL != ""
                        ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                        : "#"
                    }
                    target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                  >
                    <img
                      loading="lazy"
                      src={WhatsappIcon12}
                      alt="Whatsapp Icon"
                      width={18}
                    />
                    <span>Whatsapp</span>
                  </a>
                </li>
                <li>
                  <a
                    className="panel"
                    href={
                      appDetails?.TELEGRAM != "" ? appDetails?.TELEGRAM : "#"
                    }
                    target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
                  >
                    <img
                      loading="lazy"
                      src={TelegramIcon1}
                      alt="Telegram Icon"
                      width={18}
                    />
                    <span>Telegram</span>
                  </a>
                </li>
                <li>
                  <a
                    className="panel"
                    href={
                      appDetails?.INSTAGRAM != "" ? appDetails?.INSTAGRAM : "#"
                    }
                    target={appDetails?.INSTAGRAM != "" ? "_blank" : ""}
                  >
                    <img
                      loading="lazy"
                      src={InstaIcon1}
                      alt="Instagram Icon"
                      width={18}
                    />
                    <span>Instagram</span>
                  </a>
                </li>

                <li>
                  <a
                    href={
                      appDetails?.FACEBOOK != "" ? appDetails?.FACEBOOK : "#"
                    }
                    target={appDetails?.FACEBOOK != "" ? "_blank" : ""}
                  >
                    <img
                      loading="lazy"
                      src={Facebook1}
                      alt="Email Icon"
                      width={18}
                    />
                    <span>Facebook</span>
                  </a>
                </li>
              </ul>
            </Dropdown.Menu>
          </Dropdown>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
